export interface ITripMainProps {
  tripId: number;
}

export enum ETripMainTab {
  cargos = 'cargos',
  documents = 'documents',
  expenses = 'expenses',
  additionalCosts = 'additional-costs',
}
